var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1406(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1071,
    height: 394,
    viewBox: "0 0 1071 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "vectorMask",
    width: 920,
    height: 243,
    rx: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.978,
    y1: 0.977,
    x2: 0.021,
    y2: 0.036,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#502c84",
    stopOpacity: 0.404
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.141
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_177",
    x: 0,
    y: 0,
    width: 1071,
    height: 394,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#075a2e",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406",
    transform: "translate(60.5 60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_18",
    "data-name": 18
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 920,
    height: 243,
    rx: 18,
    fill: "#00105c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Rectangle",
    "data-name": "Mask by Rectangle",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Rectangle-2",
    "data-name": "Mask by Rectangle",
    transform: "translate(-69.423 -66.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    d: "M1511.8,1387h173.364v137.062h0l-444.526,13.579c-35.258,1.077-44.442-6.853-20.545-17.74L1511.8,1387Z",
    transform: "translate(-696.011 -1320.878)",
    fill: "#798bff",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    d: "M1649.852,1555.75l-389.727-17.359c-35.153-1.566-53.231,8.3-40.445,22.075l94.433,101.715h349.472l37.234-77.408C1707.787,1570.29,1685,1557.316,1649.852,1555.75Z",
    transform: "translate(-680.383 -1296.448)",
    fill: "#00105c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M1033.288,1426.178c0-46.424,585.595-96.1,696.389-96.1s-25.555,123.677-276.639,135.189-140.289,68-251.083,68S1033.288,1472.6,1033.288,1426.178Z",
    transform: "translate(-1004.755 -1330.074)",
    fill: "#082ac8",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    d: "M1182.745,1575.561c-139.278,76.026,27.82,30.413-159.722,101.238l583.944-5.669c-42.44-56.282-53.028-48.454-164.194-72.011s178.972-127.736,123.305-132.779S1322.022,1499.534,1182.745,1575.561Z",
    transform: "translate(-1023.023 -1308.132)",
    fill: "#798bff",
    opacity: 0.502
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -60.5, -60)",
    filter: "url(#Rectangle_177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177-2",
    "data-name": "Rectangle 177",
    width: 920,
    height: 243,
    rx: 18,
    transform: "translate(60.5 60.5)",
    stroke: "rgba(0,0,0,0.05)",
    strokeWidth: 1,
    opacity: 0.901,
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1406);
export default __webpack_public_path__ + "static/media/Group-1406.2693ca0ea36f024ababa3e92d93afdc3.svg";
export { ForwardRef as ReactComponent };